module.exports = __webpack_public_path__ + "static/usabilityTesting-e125390087d577a38ed702e373821138.svg";